import styled from '@emotion/styled';

export const AccordionWrapper = styled.div`
  margin: 75px auto;
`;

export const AccordionContent = styled.p`
  margin: 0;
  white-space: pre-line;
  padding: 20px;
  ol {
    list-style: decimal !important;
    padding-left: 30px !important;
    ol {
      list-style: lower-alpha !important;
    }
  }
  ul {
    list-style: disc !important;
    padding-left: 30px !important;
  }
`;
